module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/attachmentpoints/attachmentpoints-form/attachmentpoints-form.component.css
// module id = ./src/app/attachmentpoints/attachmentpoints-form/attachmentpoints-form.component.css
// module chunks = main